<template>
	<div>
		<div class="filter-inline-panel cle">
			<el-form :inline="true" :model="filterForm" class="filter-panel">
			</el-form>
			<div class="list-opinion fr">
				<el-button type="primary" size="mini" @click="add('')" v-if="hasBtn('add')">{{$t('index.add')}}</el-button>
			</div>
		</div>
		<el-table :data="list" size="mini" border row-key="list_index" default-expand-all>
			<el-table-column :prop="lang=='cn'?'name_cn':'name'" align="" :label="$t('course_sort.name')" width="400"></el-table-column>
			<el-table-column prop="type" align="center" :label="$t('course_sort.type')" :formatter="type_f"></el-table-column>
			<el-table-column prop="age" align="center" :label="$t('course_sort.age_age')"></el-table-column>
			<el-table-column prop="sort" align="center" :label="$t('index.sort')"></el-table-column>
			<el-table-column :label="$t('index.operation')" align="center" width="390">
				<template slot-scope="scope">
					<el-button size="mini" type="primary" v-if="hasBtn('edit')" @click="add(scope.row)">{{$t('index.edit')}}</el-button>
					<el-button size="mini" type="info" v-if="hasBtn('del')" @click="del(scope.row)">{{$t('index.del')}}</el-button>
					<el-button size="mini" type="primary" v-if="hasBtn('add_sub')&&add_subset_f(scope.row)" @click="add_add(scope.row)">{{$t('index.add_subset')}}</el-button>
					<el-button size="mini" type="primary" v-if="hasBtn('form')&&add_subset_ff(scope.row)" @click="binding(scope.row)">{{$t('course_sort.binding')}}</el-button>
				</template>
			</el-table-column>
		</el-table>
		<!-- 评估表 -->
		<el-dialog :title="$t('index.dialog_title')" :close-on-click-modal="false" :visible.sync="binding_is" width="90%" class="min_w1200">
			<el-form label-width="80px" ref="bindingform" size="mini" label-position="top" :rules="editFormRules" :model="bindingform">
				<table class="table_table">
					<tr v-for="(items,indexs) in bindingform.form" :key="indexs">
						<td v-for="(item,index) in items" :key="index">
							<el-form-item>
								<el-col :span="23">
									<el-switch v-model="item.type" :active-text="$t('course_sort.type_active')" active-value="1" inactive-value="0" :inactive-text="$t('course_sort.type_inactive')"></el-switch>
								</el-col>
								<el-col :span="23">
									<el-input v-model="item.name" :placeholder="$t('index.pleaseInput')" :rows="2" type="textarea" class="textarea"></el-input>
								</el-col>
							</el-form-item>
						</td>
					</tr>
				</table>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="mini" type="primary" @click.native="add_2('editForm')">加一竖</el-button>
				<el-button size="mini" type="primary" @click.native="add_1('editForm')">加一横</el-button>
				<el-button size="mini" type="primary" @click.native="del_1('editForm')">删一竖</el-button>
				<el-button size="mini" type="primary" @click.native="del_2('editForm')">删一横</el-button>
				<el-button size="mini" @click.native="binding_is = false">{{$t('index.cancel')}}</el-button>
				<el-button size="mini" type="primary" @click.native="bindingSubmit('editForm')">{{$t('index.submit')}}</el-button>
			</div>
		</el-dialog>
		<!-- 编辑 -->
		<el-dialog :title="$t('index.dialog_title')" :close-on-click-modal="false" :visible.sync="editFormVisible" width="1000px">
			<el-form ref="editForm" size="mini" label-position="top" :rules="editFormRules" :model="editForm">
				<el-row :gutter="20">
					<el-col :span="6">
						<el-form-item :label="$t('index.cn')+$t('course_sort.name')" prop="name_cn" data-name="分类名称">
							<el-input v-model="editForm.name_cn" :placeholder="$t('index.pleaseInput')"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item :label="$t('index.en')+$t('course_sort.name')" prop="name" data-name="分类名称">
							<el-input v-model="editForm.name" :placeholder="$t('index.pleaseInput')"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item :label="$t('course_sort.link')" prop="teaching_plan" data-name="教案链接">
							<el-input v-model="editForm.teaching_plan" :placeholder="$t('index.pleaseInput')"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item :label="$t('course_sort.syllabus')" prop="syllabus" data-name="课程大纲">
							<el-upload :action="http+'uploadImg'" class="dib" :show-file-list="false" :on-success="imageSuccess_">
								<el-button type="primary">{{$t('index.upload')}}</el-button>
							</el-upload>
							<el-button type="primary" v-if="editForm.syllabus" @click="download(editForm.syllabus)">{{$t('virtualmaillist.preview')}}</el-button>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item :label="$t('index.sort')" prop="sort" data-name="排序">
							<el-input v-model="editForm.sort" :placeholder="$t('index.pleaseInput')"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6" v-if="editForm.level==1">
						<el-form-item :label="$t('course_sort.type')" prop="type" data-name="类型">
							<el-select v-model="editForm.type" class="w100" :placeholder="$t('index.select')">
								<el-option v-for="(item,index) in TYPE" :key="index" :label="lang=='cn'?item.name_cn:item.name" :value="item.code"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="6" v-if="editForm.level==1">
						<el-form-item :label="$t('course_sort.is_jingsai')" prop="is_jingsai" data-name="是否是竞赛">
							<el-switch v-model="editForm.is_jingsai" :inactive-value="0" :active-value="1" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
						</el-form-item>
					</el-col>
					<el-col :span="6" v-if="editForm.level>=3">
						<el-form-item :label="$t('course_sort.age_age')" prop="age" data-name="年龄">
							<el-input v-model="editForm.age" :placeholder="$t('index.pleaseInput')"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="20" v-if="editForm.level==1&&editForm.is_jingsai==1">
					<el-col :span="12">
						<el-form-item :label="$t('index.cn')+$t('course_sort.content')" prop="content_cn" data-name="竞赛说明">
							<editor-bar v-model="editForm.content_cn" :isClear="isClear"></editor-bar>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item :label="$t('index.en')+$t('course_sort.content')" prop="content" data-name="竞赛说明">
							<editor-bar v-model="editForm.content" :isClear="isClear"></editor-bar>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="mini" @click.native="editFormVisible = false">{{$t('index.cancel')}}</el-button>
				<el-button size="mini" type="primary" @click.native="editSubmit('editForm')">{{$t('index.submit')}}</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
// import EditorBar from '@/components/wangEnduit.vue'
export default {
	computed: {
		editFormRules() {
			return {
				name: [{
					required: true,
					message: this.$t('index.pleaseInput') + this.$t('index.en') + this.$t('course_sort.name'),
					trigger: 'blur'
				}, ],
				name_cn: [{
					required: true,
					message: this.$t('index.pleaseInput') + this.$t('index.cn') + this.$t('course_sort.name'),
					trigger: 'blur'
				}, ],
				age: [{
					required: true,
					message: this.$t('index.pleaseInput') + this.$t('course_sort.age_age'),
					trigger: 'blur'
				}, ],
				type: [{
					required: true,
					message: this.$t('index.select') + this.$t('course_sort.type'),
					trigger: 'change'
				}, ],
			}
		},
		props() {
			return {
				value: 'id',
				label: this.lang == 'cn' ? 'name_cn' : 'name',
				children: 'children',
				checkStrictly: true,
			}
		}
	},
	components: {
		// EditorBar,
	},
	data() {
		return {
			filterForm: {},
			list: [],
			list_data: [],
			editForm: {},
			editFormVisible: false,
			pages: {
				page: 1,
				count: 100,
				perpage: 20,
			},
			list_index: 0,
			TYPE: [],
			binding_is: false,
			isClear: false,
			bindingform: {
				form: [
					[]
				],
			},
			http: process.env.API_UP,
		}
	},
	// 初始事件
	mounted: function () {
		this.config();
		this.init();
	},
	// 事件
	methods: {
		config() {
			var this_ = this;
			var url = "getDictionaryValue";
			var datas = {
				code: 'TYPE',
			}
			this_.$post(url, datas).then((res) => {
				this_.TYPE = res.TYPE;
			})
		},
		// 初始化
		init: function () {
			var this_ = this;
			var url = "cateOption";
			var datas = {}
			this_.$post(url, {}).then((res) => {
				var list = this_.xunhaun(res.show, 10);
				var list_data = this_.xunhaun(res.hide, 10000);
				this_.list = list;
				this_.list_data = res.hide;
			})
		},
		add(data) {
			if (data) {
				this.editForm = JSON.parse(JSON.stringify(data));;
			} else {
				this.editForm = {
					name: '',
					name_cn: '',
					is_jingsai: 0,
					content: '',
					syllabus: '',
					teaching_plan: '',
					content_cn: '',
					sort: 0,
					type: '0',
					level: 1,
				}
			}
			if (this.$refs.editForm) {
				this.$refs.editForm.resetFields();
			}
			this.editFormVisible = true;
		},
		add_add(data) {
			console.log(data);
			var editForm = JSON.parse(JSON.stringify(data));
			this.editForm = {
				name: '',
				teaching_plan: '',
				syllabus: '',
				name_cn: '',
				parent_id: editForm.id,
				age: '',
				sort: 0,
				type: editForm.type,
				level: editForm.level + 1,
			}
			if (this.$refs.editForm) {
				this.$refs.editForm.resetFields();
			}
			this.editFormVisible = true;
		},
		editSubmit() {
			var this_ = this;
			this_.$refs.editForm.validate((valid) => {
				if (valid) {
					var datas = {
						name: this_.editForm.name,
						name_cn: this_.editForm.name_cn,
						syllabus: this_.editForm.syllabus,
						teaching_plan: this_.editForm.teaching_plan,
						type: this_.editForm.type,
						sort: this_.editForm.sort,
					}
					if (this_.editForm.level == 1) {
						var url = "cateAction";
						datas['is_jingsai'] = this_.editForm.is_jingsai;
						datas['content'] = this_.editForm.content;
						datas['content_cn'] = this_.editForm.content_cn;
					} else if (this_.editForm.level == 2) {
						var url = "cateChildrenAction";
						datas['parent_id'] = this_.editForm.parent_id;
					} else if (this_.editForm.level >= 3) {
						var url = "cateThreeAction";
						datas['parent_id'] = this_.editForm.parent_id;
						datas['age'] = this_.editForm.age;
						datas['level'] = 1;
					}
					if (this_.editForm.level == 4) {
						datas['level'] = 2;
					}
					var tishi = this_.$t('index.add_success');
					if (this_.editForm.id) {
						datas['id'] = this_.editForm.id;
						tishi = this_.$t('index.modify_success');
					}
					this_.$post(url, datas).then((res) => {
						this_.$message.success(tishi);
						this_.editFormVisible = false;
						this_.init();
					});
				}
			})
		},
		del(data) {
			var this_ = this;
			if (data.level == 1) {
				var url = "cateDelete";
			} else if (data.level == 2) {
				var url = "cateChildrenDelete";
			} else if (data.level >= 3) {
				var url = "cateThreeDelete";
			}
			var datas = {
				id: data.id
			};
			this_.$confirm(this_.$t('index.confirm_delete'), this_.$t('index.tips')).then(() => {
				this_.$post(url, datas).then((res) => {
					this_.$message.success(this_.$t('index.delete_success'));
					this_.init();
				})
			}).catch(() => {});
		},
		type_f(w, s, d) {
			var this_ = this;
			var name = '';
			var list = this.TYPE;
			list.forEach(function (e, i) {
				if (e.code == d) {
					name = this_.lang == 'cn' ? e.name_cn : e.name;
				}
			});
			return name;
		},
		// 子集按键展示
		add_subset_f(data) {
			var zhi = true;
			if ((data.type == 1 && data.level == 4) || (data.type == 2 && data.level == 3)) {
				zhi = false;
			}
			return zhi;
		},
		add_subset_ff(data) {
			var zhi = false;
			if (data.type == 1 && data.level <= 2) {
				zhi = true;
			}
			return zhi;
		},

		binding(data) {
			var bindingform = JSON.parse(JSON.stringify(data));
			var form = [[]];
			if (bindingform.form) {
				form = JSON.parse(bindingform.form);
			}
			bindingform['form'] = form;
			this.bindingform = bindingform;
			console.log()
			this.binding_is = true;
		},
		add_1() {
			var form = this.bindingform.form || [[]];
			if (form.length > 0) {
				var list = [];
				for (var i = 0; i < form[0].length; i++) {
					var obj = {
						name: '',
						type: '0',
					}
					list[i] = obj;
				}
				form.push(list);
				this.bindingform.form = form;
			}
		},
		add_2() {
			var form = this.bindingform.form || [[]];
			for (var i = 0; i < form.length; i++) {
				var obj = {
					name: '',
					type: '0',
				}
				form[i].push(obj);
			}
			this.bindingform.form = form;
		},
		del_1() {
			var this_ = this;
			var form = this.bindingform.form;
			if (form.length > 0) {
				for (var i = 0; i < form.length; i++) {
					if (form[i].length > 0) {
						this_.removeByIndex(form[i], form[i].length - 1);
					}
				}
			}
		},
		del_2() {
			var this_ = this;
			var form = this.bindingform.form;
			if (form.length > 0) {
				this_.removeByIndex(form, form.length - 1);
			}
		},
		bindingSubmit() {
			var this_ = this;
			if (this_.bindingform.level == 1) {
				var url = "cateAction";
			}else if(this_.bindingform.level == 2){
				var url = "catechildrenAction";
			}
			var form = '[[]]'
			if(this_.bindingform.form.length>0){
				form = JSON.stringify(this_.bindingform.form);
			}
			var datas = {
				id: this_.bindingform.id,
				form: form,
			}
			this_.$post(url, datas).then((res) => {
				this_.$message.success(this_.$t('index.operation_success'));
				this_.binding_is = false;
				this_.init();
			});
		},
		// 头像上传
		imageSuccess_(res, file) {
			var this_ = this;
			if (res.status == 200) {
				this_.editForm.syllabus_url = res.data.savename;
				this_.editForm.syllabus = res.data.showname;
			} else {
				this_.$message.success(res.message);
			}
		},
		download(url) {
			var el = document.createElement("a");
			document.body.appendChild(el);
			el.href = url; //url 是你得到的连接
			el.target = '_blank'; //指定在新窗口打开
			el.click();
			document.body.removeChild(el);
		},
	},
	// 过滤器
	filters: {

	}
}
</script>
<style>
.avatar-uploader .el-upload {
	border: 1px dashed #d9d9d9;
	border-radius: 6px;
	cursor: pointer;
	position: relative;
	overflow: hidden;
}
.avatar-uploader .el-upload:hover {
	border-color: #409EFF;
}
.avatar-uploader-icon {
	font-size: 28px;
	color: #8c939d;
	width: 100px;
	height: 100px;
	line-height: 100px;
	text-align: center;
}
.avatar {
	width: 100px;
	height: 100px;
	display: block;
}
.table_table .textarea textarea {
	font-family: initial
}
.min_w1200 .el-dialog {
	min-width: 1200px;
}
</style>
<style scoped>
.dib {
	display: inline-block;
}
.filter-inline-panel {
	margin-bottom: 18px;
}
.pingweibuyao {
	position: absolute;
	left: -142px;
	top: 0;
	width: 1px;
	opacity: 0;
}
.content-panel {
	min-height: calc(100vh - 252px);
	background: #ffffff;
	padding: 25px 30px;
}
.content-panel .page-pagination {
	padding: 25px 10px;
	text-align: right;
}
.content-panel .page-pagination .filter-inline-panel {
	margin-bottom: 25px;
}
.content-panel .page-pagination .filter-inline-panel .add-data-base .el-select {
	width: 100%;
}
.filter-panel {
	display: inline-block;
	width: 80%;
	vertical-align: top;
}
.list-opinion {
	display: inline-block;
	width: 18%;
	text-align: right;
	vertical-align: top;
}
.dialog-bottom-btn {
	text-align: center;
}
.list-btn-group {
	margin: 0;
}
.list-btn-group a {
	color: #1890FF;
	cursor: pointer;
	margin: 0 5px;
}
.col_bai:hover,
.col_bai {
	color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/teacher/course_sort.vue